import { LOAD_FAVICON, LOAD_LOGO, PUBLIC_CONFIG_LOADED } from '../../actions/configuration';

export const defaultState = {
    customer: '',
    logo: 'iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4wsFBiQU87VLxgAAAB1pVFh0Q29tbWVudAAAAAAAQ3JlYXRlZCB3aXRoIEdJTVBkLmUHAAAAC0lEQVQI12NgAAIAAAUAAeImBZsAAAAASUVORK5CYII=',
    favicon: '=AAABAAEAEBAAAAEACABoBQAAFgAAACgAAAAQAAAAIAAAAAEACAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABtSBsAc1AlAHVSJwB6WC8Afl43AIFiOwCCYjwAiWxIAIxvTACSdlUAk3hXAJR5WQCVe1oAmX9gAJyDZACcg2UAnoVoAKGJbAChim0Ap5F2AKmUegCumoEAuKaRALqplAC9rZkAwbGeAMa4pwDIuqkAyLuqAMm7qwDJvKwA0MW2ANLHugDXzcEA2M7CAN7WzADk3tYA5d7XAObg2ADq5d8A7ejjAO3p5ADw7ekA8u/rAPf18wD49vQA+fj2APz7+wD9/f0A/v7+AP///wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMjIyMjIyMjIyMjIyMjIyMjIyMjIyCSYyMg4jMjIyMjIyMjIyMhoAAAAGMjIyMjIyMjIyMjIsBzIeFjIyMjIyMjIyMjIyMhEkDSgyMjIyMjIyMjIyMjIiFAwyMjIyMjIyMjIyMjIyMQQcMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIvAjIyMjIfEDIyLgMrMjIyLwIyGwEtHxAyMjIVFzIyMi8CMgoTHR8QMjIyJwUxMjIvAikKKAsfEDIyMjIMITIyLwIWGzIKGRAyMjIyIA8yMi8CBywyHAgQMjIyMjAFKjIvABIyMi0BEDIlAAAAABgyMjIyMjIyMjIyMjIyMjIyMgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA=',
    appTitle: '',
    appName: '',
    envTitle: '',
    contacts: {
        companyName: '',
        address: [],
        phones: [],
        faxes: [],
        web: '',
        other: [],
    },
    auctionCalendar: null,
    dbgLoginURL: '',
    dbgLoginClientID: '',
    ssoEnabled: false,
};

const publicConfig = (state = defaultState, action = undefined) => {
    switch (action.type) {
        case PUBLIC_CONFIG_LOADED:
            return {
                customer: action.payload.customer,
                logo: action.payload.logo,
                favicon: action.payload.favicon,
                appTitle: action.payload.appTitle,
                appName: action.payload.appName,
                envTitle: action.payload.envTitle,
                contacts: action.payload.contacts,
                auctionCalendar: action.payload.auctionCalendar,
                dbgLoginURL: action.payload.dbgLoginURL,
                dbgLoginClientID: action.payload.dbgLoginClientID,
                ssoEnabled: action.payload.ssoEnabled,
            };
        case LOAD_FAVICON:
            return { ...state, favicon: action.payload };
        case LOAD_LOGO:
            return { ...state, logo: action.payload };
        default:
            return state;
    }
};

export default publicConfig;
